<template>
  <div id="importMain" style="height: calc(100% - 80px)">
    <!-- 碳排放强度 -->
  </div>
</template>

<script>
import * as echarts from 'echarts';
import array from 'es6-iterator/array';
export default {
  name: "importEmission",
  // props: ['importantxData', 'turnData', 'brokenData', 'rawData', 'coalMillData'],
  props: {
    importantxData: {
      type: array
    },
    turnData: {
      type: array
    },
    brokenData: {
      type: array
    },
    rawData: {
      type: array
    },
    coalMillData: {
      type: array
    }
  },
  watch: {

  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
    let importchartDom = document.getElementById('importMain');
    let importmyChart = echarts.init(importchartDom);
    let importMain;
    importMain = {
      title: {
        //text: '单位:万tCO₂',
        text: '单位:吨',//重点区域用能排名
        textStyle: {
          color: '#fff',
          fontSize: 16,
        }
      },
      tooltip: {
        padding: [8, 10, 8, 10],
        backgroundColor: 'rgba(9,17,24)',
        borderWidth: 1,
        borderColor: '#45a2ff',
        trigger: 'axis',
        textStyle: {
          color: '#fff'
        },

        // formatter: function (params) {
        //   console.log(params)
        //   var res = ''
        //   for (var i = 0, l = params.length; i < l; i++) {
        //     res += params[i].seriesName + ' : ' + params[i].value + '<br/>';//鼠标悬浮显示的字符串内容
        //     // console.log(res)
        //   }
        //   var str = `<div style="color:#fff; background-size: cover;;font-size:16px;">`
        //     + res +
        //     `</div>`;
        //   // parms.marker
        //   // console.log(params);
        //   return str;
        // }
      },
      legend: {
        // type:'scrool',
        orient: 'vertical',
        data: ['原料磨1', '原料磨2', '窑主传1', '窑主传2', '高温风机', '头排风机', '窑头风机', '窑尾风机', '风机5', '风机6', '蓖冷机风机群', '蓖冷机风机群2'],
        right: 10,
        textStyle: {
          color: '#fff',
          fontSize: 16
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        feature: {
          // saveAsImage: {}
        }
      },
      xAxis: {
        // show: 'false,
        type: 'category',
        boundaryGap: true,
        data: ['原料磨1', '原料磨2', '窑主传1', '窑主传2', '高温风机', '头排风机', '窑头风机', '窑尾风机', '风机5', '风机6', '蓖冷机风机群', '蓖冷机风机群2'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#45a2ff',
          },
        },
        splitLine: { show: false },//去除网格线
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 16,
          color: '#fff',
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#45a2ff',
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: '#182266',
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 14,
          color: '#fff',
        },
      },
      series: [
        {
          data: [8, 10, 8, 3, 7, 5, 2, 3, 15, 5, 8, 7, 12],
          type: 'bar',
          // showBackground: true,
          // backgroundStyle: {
          //   color: 'rgba(180, 180, 180, 0.2)'
          // },
          itemStyle: {
            normal: {
              color: function (params) {
                // 给出颜色组
                var colorList = ['#3e93e7', '#4fc7a3', '#eb5685', '#e9b923', '#d974d4', '#3ccb3e', '#f4ac34', '#4587E7', '#F5AD1D', '#ea7ccc', '#5470c6', '#ee6666']

                return colorList[params.dataIndex]
              },
            }
          },
          barWidth: '40%'
        }
      ]
      // series: [
      //   {
      //     name: '回转窑',
      //     type: 'bar',
      //     // stack: 'Total',
      //     showSymbol: true,//是否默认展示圆点
      //     legendHoverLink: true,
      //     // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
      //     symbol: 'circle',     //设定为实心点
      //     symbolSize: 12,   //设定实心点的大小
      //     data: this.turnData
      //   },
      //   {
      //     name: '破碎机',
      //     type: 'bar',
      //     // stack: 'Total',
      //     showSymbol: true,//是否默认展示圆点
      //     legendHoverLink: true,
      //     // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
      //     symbol: 'circle',     //设定为实心点
      //     symbolSize: 12,   //设定实心点的大小
      //     data: this.brokenData
      //   },
      //   {
      //     name: '原料磨',
      //     type: 'bar',
      //     // stack: 'Total',
      //     showSymbol: true,//是否默认展示圆点
      //     legendHoverLink: true,
      //     // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
      //     symbol: 'circle',     //设定为实心点
      //     symbolSize: 12,   //设定实心点的大小
      //     data: this.rawData
      //   },
      //   {
      //     name: '磨煤机',
      //     type: 'bar',
      //     // stack: 'Total',
      //     showSymbol: true,//是否默认展示圆点
      //     legendHoverLink: true,
      //     // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
      //     symbol: 'circle',     //设定为实心点
      //     symbolSize: 12,   //设定实心点的大小
      //     data: this.coalMillData
      //   }
      // ]
    };
    importMain && importmyChart.setOption(importMain);
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/left/importEmission.vue